import { render, staticRenderFns } from "./Overlay01.vue?vue&type=template&id=bc55e9de&scoped=true"
import script from "./Overlay01.vue?vue&type=script&lang=js"
export * from "./Overlay01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc55e9de",
  null
  
)

export default component.exports